import Vue from "vue";
import VueRouter from "vue-router";
import router from "./router";
import ElementUI from "element-ui";
// import { Message } from 'element-ui';
import "@/assets/js/http_axios";
import "element-ui/lib/theme-chalk/index.css";
import common from "@/assets/js/comm.js";
import App from "./App.vue";
import "default-passive-events";
import Print from "@/assets/js/print.js";
import Tools from "@/assets/js/tool";
import comAPI from "@/assets/js/comAPI.js";
import { Api } from "@/assets/js/api";
import { showLoading, hideLoading } from "@/assets/js/loading";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleUp, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import permission from "@/assets/js/directives/permission.js";

library.add(faAngleDoubleUp, faAngleDoubleDown)

import VueQuillEditor from "vue-quill-editor";

// 引入样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 弹出框
import Dialog from '@/components/dialog/index.vue'
Vue.use(VueQuillEditor);
// 全局注册组件
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('Dialog', Dialog);
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Print);

// element弹出框拖动指令
import "@/assets/js/directives/dialog.js";
// 自定义打印系统需要
import { hiPrintPlugin } from "./print.js";
Vue.use(hiPrintPlugin);

import 'vxe-table/lib/style.css'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import XEUtils from 'xe-utils'

Vue.use(VXETable)
VXETable.use(VXETablePluginElement)
VXETable.setup({ XEUtils })


// 自定义打印系统需要
import Storage from "vue-ls";
let options = {
  namespace: "hiPrint-",
  name: "ls",
  storage: "local",
};
Vue.use(Storage, options);

function hasBtnPermission(permission) {
  let PermissionArr = JSON.parse(sessionStorage.getItem("btnPermiss")) || [];
  return PermissionArr.indexOf(permission) > -1;
}
Vue.prototype.hasPermiss = hasBtnPermission;
Vue.prototype.common = common;
Vue.prototype.Tools = Tools;
Vue.prototype.$TOOLS = Tools;
Vue.prototype.$comAPI = comAPI;
Vue.prototype.$API = Api;
Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;

// 注意：这里使用的$message,所以在使用时候也是this.$message
Vue.prototype.$message = function(msg) {
  return ElementUI.Message({
    message: msg,
    duration: 1800,
    showClose: true,
  });
};
//分别对success、warning和error等样式进行设置
Vue.prototype.$message.success = function(msg) {
  return ElementUI.Message.success({
    message: msg,
    duration: 1800,
    showClose: true,
  });
};
Vue.prototype.$message.warning = function(msg) {
  return ElementUI.Message.warning({
    message: msg,
    duration: 2000,
    showClose: true,
  });
};
Vue.prototype.$message.error = function(msg) {
  return ElementUI.Message.error({
    message: msg,
    duration: 2000,
    showClose: true,
  });
};


// 对象类型检测
Vue.prototype.$getObject = function(v) {
  let s = Object.prototype.toString.call(v);
  if (s == "[object Object]") {
    return "Object";
  } else if (s == "[object Null]") {
    return "Null";
  } else if (s == "[object Number]") {
    return "Number";
  } else if (s == "[object Boolean]") {
    return "Boolean";
  } else if (s == "[object String]") {
    return "String";
  } else if (s == "[object Array]") {
    return "Array";
  } else if (s == "[object Date]") {
    return "Date";
  } else if (s == "[object Function]") {
    return "Function";
  } else if (s == "[object Undefined]") {
    return "Undefined";
  } else {
    return s;
  }
};

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
}).$mount("#app");
Vue.prototype.$keyBoard = function(vm, methodName, code) {
  document.onkeydown = function() {
    let key = window.event.keyCode;
    if (key == code) {
      vm[methodName](code); // 触发methodName事件
    }
  };
};
